<template>
  <m-chip-set
    :input="true">
    <m-chip
      v-for="chip in chipset"
      :key="chip.chip">
      <m-icon
        v-if="chip.icon"
        :slot="chip.icon.slot"
        :icon="chip.icon.icon" />
      {{ chip.chip }}
    </m-chip>
  </m-chip-set>
</template>

<script>
import Vue from 'vue'
import Chip from 'material-components-vue/dist/chips'
import Icon from 'material-components-vue/dist/icon'
Vue.use(Icon)
Vue.use(Chip)

export default {
  props: {
    chipset: { required: true, type: [Array] }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../universal/vars.scss';
  @import "material-components-vue/dist/chips/styles";
  @import "./chips"
</style>
